<div class="bg-white rounded-xl shadow-sm relative">
    <!-- Form Header -->
    <div class="flex items-center justify-between border-b border-gray-200 absolute right-1">
        <button (click)="closeForm()"
            class="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors duration-150">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
        </button>
    </div>

    <!-- Form Content -->
    <form [formGroup]="addressForm" class="py-6 text-sm">

        <div class="grid grid-cols-1 gap-6">
            <div class="grid grid-cols-1 gap-4">
                <p class="text-xl font-semibold">Contact Details</p>
                <div class="grid grid-cols-1 gap-4">
                    <div class="grid grid-cols-2 gap-4 my-2">
                        <!-- Phone Number -->
                        <div class="space-y-2">
                            <input type="tel" id="address_phone" placeholder="Phone number" formControlName="phone"
                                class="w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-colors duration-150"
                                [class.border-red-300]="addressForm.get('phone')?.hasError('phone') && addressForm.get('phone')?.touched">
                            <p *ngIf="(addressForm.get('phone')?.hasError('phone') || addressForm.get('phone')?.hasError('required')) && addressForm.get('phone')?.touched"
                                class="text-red-600 text-xs mt-1">
                                Please enter a valid phone number
                            </p>
                        </div>
                        <!-- Email -->
                        <div class="space-y-2">
                            <input type="email" id="address_email" placeholder="Email address" formControlName="email"
                                class="w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-colors duration-150"
                                [class.border-red-300]="addressForm?.get('email')?.hasError('email') && addressForm?.get('email')?.touched">
                            <p *ngIf="(addressForm?.get('email')?.hasError('email') || addressForm?.get('email')?.hasError('required')) && addressForm?.get('email')?.touched"
                                class="text-red-600 text-xs mt-1">
                                Please enter a valid email address
                            </p>
                        </div>
                    </div>
                    <!-- Receiver's Name -->
                    <div class="space-y-2">
                        <input type="text" id="receiver_name" placeholder="Full name" formControlName="receiver_name"
                            class="w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm 
            focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent 
            transition-colors duration-150"
                            [class.border-red-300]="addressForm?.get('receiver_name')?.hasError('text') && addressForm?.get('receiver_name')?.touched">
                        <p *ngIf="addressForm?.get('receiver_name')?.hasError('text') && addressForm?.get('receiver_name')?.touched"
                            class="text-red-600 text-xs mt-1">
                            Please enter a valid name (letters only)
                        </p>
                    </div>

                </div>
            </div>

            <div class="grid grid-cols-1 gap-4">
                <p class="text-xl font-semibold">Delivery Address</p>
                <div class="grid grid-cols-1 gap-4">
                    <div class="space-y-2">
                        <label for="apartment_no" class="block text-sm font-medium text-gray-700">
                            Apartment/Unit Number/Floor
                        </label>
                        <input type="text" id="apartment_no" placeholder="Apt, suite, unit, etc."
                            formControlName="apartment_no"
                            class="w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-colors duration-150">
                    </div>
                    <!-- Address Line -->
                    <div class="space-y-2">
                        <label for="address_line" class="block text-sm font-medium text-gray-700">
                            Street Address <span class="text-red-500">*</span>
                        </label>
                        <input type="text" id="address_line" autocomplete="street-address"
                            placeholder="Enter street address" formControlName="address_line"
                            class="w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-colors duration-150"
                            [class.border-red-300]="addressForm?.get('address_line')?.hasError('required') && addressForm?.get('address_line')?.touched">
                        <p *ngIf="addressForm?.get('address_line')?.hasError('required') && addressForm?.get('address_line')?.touched"
                            class="text-red-600 text-xs mt-1">
                            Street address is required
                        </p>
                    </div>

                    <div class="grid grid-cols-2 gap-2">
                        <div class="space-y-2 mb-1">
                            <label for="pincode" class="block text-sm font-medium text-gray-700">
                                Postal/ZIP Code <span class="text-red-500">*</span>
                            </label>
                            <div class="relative">
                                <input type="text" id="pincode" autocomplete="postal-code"
                                    placeholder="Enter postal/ZIP code" formControlName="pincode"
                                    class="w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-colors duration-150"
                                    [class.border-red-300]="addressForm?.get('pincode')?.errors && addressForm?.get('pincode')?.touched"
                                    [class.border-green-300]="showPinCodeSuccess">

                                <!-- Loading spinner -->
                                <div *ngIf="isPincodeValidating" class="absolute right-3 top-1/2 transform -translate-y-1/2">
                                    <svg class="animate-spin h-4 w-4 text-primary" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                    </svg>
                                </div>

                                <!-- Success check -->
                                <div *ngIf="showPinCodeSuccess && !isPincodeValidating" class="absolute right-3 top-1/2 transform -translate-y-1/2">
                                    <svg class="h-4 w-4 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                                    </svg>
                                </div>
                            </div>

                            <!-- Error messages -->
                            <ng-container *ngIf="addressForm?.get('pincode')?.touched">
                                <p *ngIf="addressForm?.get('pincode')?.hasError('required')"
                                    class="text-red-600 text-xs mt-1">
                                    Postal/ZIP code is required
                                </p>
                                <p *ngIf="addressForm?.get('pincode')?.hasError('minlength') || addressForm?.get('pincode')?.hasError('maxlength')"
                                    class="text-red-600 text-xs mt-1">
                                    Postal/ZIP code must be 6 digits
                                </p>
                                <p *ngIf="addressForm?.get('pincode')?.hasError('pattern')"
                                    class="text-red-600 text-xs mt-1">
                                    Postal/ZIP code must contain only numbers
                                </p>
                                <p *ngIf="addressForm?.get('pincode')?.hasError('invalid')"
                                    class="text-red-600 text-xs mt-1">
                                    {{ addressForm?.get('pincode')?.errors?.['message'] || 'Invalid pincode' }}
                                </p>
                                <p *ngIf="addressForm?.get('pincode')?.hasError('notServiceable')"
                                    class="text-red-600 text-xs mt-1">
                                    {{ addressForm?.get('pincode')?.errors?.['message'] || 'Sorry, we do not deliver to this location' }}
                                </p>
                            </ng-container>
                            
                            <!-- Success message -->
                            <!-- <p *ngIf="showPinCodeSuccess && !addressForm?.get('pincode')?.errors" class="text-green-600 text-xs mt-1">
                                <i class="pi pi-check"></i> Pincode verified successfully
                            </p> -->
                            
                            <!-- Validating message -->
                            <p *ngIf="isPincodeValidating" class="text-yellow-600 text-xs mt-1">
                                Validating pincode...
                            </p>
                        </div>
                        
                        <!-- City Input -->
                        <div class="space-y-2 w-full">
                            <label for="city" class="block text-sm font-medium text-gray-700">
                                City <span class="text-red-500">*</span>
                            </label>
                            <input type="text" id="city" autocomplete="city" placeholder="City" formControlName="city"
                                class="w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-colors duration-150"
                                [class.border-red-300]="addressForm?.get('city')?.hasError('required') && addressForm?.get('city')?.touched"
                                [readonly]="true"
                                [class.bg-gray-50]="true">
                            <p *ngIf="addressForm?.get('city')?.hasError('required') && addressForm?.get('city')?.touched"
                                class="text-red-600 text-xs mt-1">
                                City is required
                            </p>
                        </div>
                    </div>

                    <!-- State Input -->
                    <div class="space-y-2 w-full">
                        <label for="state" class="block text-sm font-medium text-gray-700">
                            State/Province <span class="text-red-500">*</span>
                        </label>
                        <input readonly="true" [disabled]="true" type="text" id="state" autocomplete="state" placeholder="State" formControlName="state"
                            class="disabled:bg-gray-100 disabled:cursor-not-allowed w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:border-transparent transition-colors duration-150"
                            [class.border-red-300]="addressForm?.get('state')?.hasError('required') && addressForm?.get('state')?.touched">
                    </div>

                </div>
            </div>

        </div>

        <div class="md:col-span-2 mt-6">
            <div class="flex items-center">
                <input type="checkbox" id="is_default" formControlName="is_default"
                    class="h-4 w-4 text-primary border-gray-300 rounded focus:ring-primary">
                <label for="is_default" class="ml-2 block text-sm text-gray-700">
                    Set as default delivery address
                </label>
            </div>
        </div>
        
        <!-- Form Actions -->
        <div class="flex flex-col sm:flex-row gap-3 pt-6 mt-6 border-t border-gray-200">
            <button type="button" (click)="saveAddress()" 
                [disabled]="!addressForm.valid || isPincodeValidating"
                class="inline-flex justify-center items-center px-6 py-3 border border-transparent
           text-sm font-medium rounded-lg text-white bg-primary hover:bg-primary-light 
           focus:outline-none focus:ring-2 focus:ring-offset-2 
          focus:ring-primary transition-colors duration-150 disabled:opacity-50 disabled:cursor-not-allowed">
                <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                </svg>
                Save Address
            </button>
        </div>
    </form>
</div>